export enum Lists {
    SpeakerInfo = "Speaker Info",
    Settings = "Settings",
    ApplicationLogs = "Application Logs",
    ChoiceEntries = "ChoiceEntries",
    Invitations = "Invitations",
    SpeakerDocuments = "SpeakerDocuments"
}

export type ListKeys = keyof typeof Lists;